import { render } from "./switch-language.vue?vue&type=template&id=5c26972f&scoped=true"
import script from "./switch-language.vue?vue&type=script&lang=js"
export * from "./switch-language.vue?vue&type=script&lang=js"

import "./switch-language.vue?vue&type=style&index=0&id=5c26972f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c26972f"]])

export default __exports__